import { Injectable } from '@angular/core';

@Injectable()
export class NoolaConfig {
  /**
   * Publishable widget key (`wk_...`) — rendered as `data-noola-key`.
   */
  widget_key: string;

  /**
   * REST API origin — rendered as `data-noola-api`.
   */
  api_url: string;

  /**
   * Realtime edge origin — rendered as `data-noola-edge`.
   */
  edge_url: string;

  /**
   * Start with no launcher bubble so we can drive it from a custom button.
   * Rendered as `data-noola-hidden`.
   */
  hidden?: boolean;

  /**
   * Brand accent color — rendered as `data-noola-accent`.
   */
  accent?: string;

  /**
   * Header title — rendered as `data-noola-title`.
   */
  title?: string;
}
